<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { Icon } from '@iconify/vue'
import { HighCode } from 'vue-highlight-code';
import 'vue-highlight-code/dist/style.css';
import { useToast } from 'primevue/usetoast'
import { useVersionDetailStore } from '@/modules/setting/stores/version.detail.store.ts'

const versionDetailStore = useVersionDetailStore()

interface Props {
  id: number,
  action: string,
}

const props = defineProps<Props>()

const fetched = ref('success')
const jsonData = ref<any>({})
const codeEditor = ref(null)

const requestFetchData = async () => {
  try{

    versionDetailStore.fetchVersion(props.id)
  } catch (e) {

  }
}

const updateJsonData = (e: any) => {
  if(codeEditor.value){
    const raw = codeEditor.value.modelValue;
    // Loại bỏ dấu đơn ngoài nếu có
    const cleaned = raw.startsWith("'") ? raw.slice(1, -1) : raw;
    // Parse thành object
    const obj = JSON.parse(cleaned);
    console.log(obj); // => { cache: true }
  }

}


const version = computed(() => {
  let version;
  try{
    version = versionDetailStore?.versions[props.id] || null
  } catch (error) {
    version = null;
  }
  return {
    status: version?.version.status || '',
    version_name: version?.version.version_name || '',
    api_version: version?.version.api_version || '',
    api_url: version?.version.api_url || '',
    android_version: version?.version.android_version || '',
    android_market_url: version?.version.android_market_url || '',
    ios_version: version?.version.ios_version || '',
    ios_market_url: version?.version.ios_market_url || '',
    webview_version: version?.version.webview_version || '',
    period_start_at: version?.version.period_start_at || '',
    period_end_at: version?.version.period_end_at || '',
    created_at: version?.version.created_at || '',
  }
})

const toast = useToast();


const resolver = (e: any) => {
  const errors: any = { fullname: [], phone: [], email: [], status: [], password: [], activation_status: [] };


  return {
    values: e.values,
    errors
  };
};

const onFormSubmit = (form: any) => {
  confirm.require({
    message: 'Bạn có muốn lưu các chỉnh sửa?',
    header: 'Xác nhận',
    // icon: 'pi pi-exclamation-triangle',
    rejectProps: {
      label: 'Huỷ',
      severity: 'secondary',
      outlined: true
    },
    acceptProps: {
      label: 'Đồng ý'
    },
    accept: () => {

      toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
    },
    reject: () => {
      // toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    }
  });
};

onMounted(() => {
  requestFetchData()
})


const handleSaveConfig = () => {

}

</script>

<template>
  <template v-if="'fetching' === fetched">
    <Card>
      <template #content>
        <div class="flex gap-3">
          Đang tải dữ liệu <Icon icon="eos-icons:three-dots-loading" width="24" height="24" />
        </div>
      </template>

    </Card>
  </template>
  <template v-if="'failed' === fetched">
    <Card class="bg-red-300">
      <template #content>
        <div class="flex flex-col gap-3 items-center">
          <Icon icon="fluent-color:error-circle-16" width="50" />
          <span class="font-300 text-[16px]">Lỗi khi tải dữ liệu này</span>
        </div>
      </template>

    </Card>
  </template>
  <template v-if="'success' === fetched">
    <div class="flex gap-5 mb-5">
      <div class="flex flex-3 flex-col">
        <Card>
          <template #title>
            <div class="flex justify-between">
              <div>Thông tin phiên bản</div>
            </div>
          </template>
          <template #content>
            <Form
              v-slot="$form"
              :initial-values="version"
              :resolver="resolver"
              @submit="onFormSubmit"
              class="flex w-full"
            >
              <div class="flex flex-col flex-3">
                <div class="flex mb-3 gap-3">
                  <div class="flex-1 text-right">Phiên bản:</div>
                  <div class="flex-2">
                    <InputText name="version_name" type="text" value="1.0.0" class="form-control" disabled />
                  </div>
                </div>
                <div class="flex mb-3 gap-3">
                  <div class="flex-1 text-right">API Version:</div>
                  <div class="flex-2">
                    <InputText name="api_version" type="text" class="form-control" :disabled="false"/>
                  </div>
                </div>
                <div class="flex mb-3 gap-3">
                  <div class="flex-1 text-right">API BaseURL:</div>
                  <div class="flex-2">
                    <InputText name="api_url" type="text" class="form-control" :disabled="false"/>
                  </div>
                </div>
                <div class="flex mb-3 gap-3">
                  <div class="flex-1 text-right">Phiên bản Android:</div>
                  <div class="flex-2">
                    <InputText name="android_version" type="text" class="form-control" :disabled="false"/>
                  </div>
                </div>
                <div class="flex mb-3 gap-3">
                  <div class="flex-1 text-right">Link tải Android:</div>
                  <div class="flex-2">
                    <InputText name="android_market_url" type="text" class="form-control" :disabled="false"/>
                  </div>
                </div>
                <div class="flex mb-3 gap-3">
                  <div class="flex-1 text-right">Phiên bản iOS:</div>
                  <div class="flex-2">
                    <InputText name="ios_version" type="text" class="form-control" :disabled="false"/>
                  </div>
                </div>
                <div class="flex mb-3 gap-3">
                  <div class="flex-1 text-right">Link tải iOS:</div>
                  <div class="flex-2">
                    <InputText name="ios_market_url" type="text" class="form-control" :disabled="false"/>
                  </div>
                </div>
                <div class="flex mb-3 gap-3">
                  <div class="flex-1 text-right">Phiên bản webview:</div>
                  <div class="flex-2">
                    <InputText name="webview_version" type="text" class="form-control" :disabled="false"/>
                  </div>
                </div>
                <div class="flex mb-3 gap-3">
                  <div class="flex-1 text-right">Ngày hoạt động:</div>
                  <div class="flex-2">
                    <DatePicker :show-time="true" name="period_start_at" class="form-control" :manual-input="false" :disabled="false"/>
                  </div>
                </div>
                <div class="flex mb-3 gap-3">
                  <div class="flex-1 text-right">Ngày kết thúc:</div>
                  <div class="flex-2">
                    <DatePicker :show-time="true" name="period_end_at" class="form-control" :manual-input="false" :disabled="false"/>
                  </div>
                </div>

                <div class="flex mb-3 gap-3">
                  <div class="flex-1 text-right">Trạng thái hoạt động:</div>
                  <div class="flex-2">
                    <Select name="activation_status" :options="[
              {name: 'Hoạt động', code: 'LIVE'},
              {name: 'Ngưng hoạt động', code: 'DEPRECATED'},
            ]" optionLabel="name" placeholder="Chọn trạng thái" class="form-control" :disabled="false"/>
                  </div>
                </div>
                <div class="flex mb-3 gap-3" v-if=false>
                  <div class="flex-1 text-right"></div>
                  <div class="flex-2">
                    <button type="submit" class="btn btn-cs success lg">Lưu chỉnh sửa</button>
                  </div>
                </div>
              </div>
            </Form>
          </template>
        </Card>

      </div>
      <div class="flex flex-5 flex-col">
        <Card>
          <template #title>
            <div class="flex justify-between">
              <div>Giá trị cấu hình</div>
              <div class="flex gap-2">
                <button type="button" class="btn btn-cs success" @click="handleSaveConfig">
                  Lưu chỉnh sửa
                </button>
              </div>
            </div>
          </template>
          <template #content>
            <div class="mt-5">
              <HighCode
                :textEditor="true"
                :codeLines="false"
                :codeValue="JSON.stringify(jsonData)"
                lang="json"
                langName="json"
                width="100%" height="300px" fontSize="12px"
                :copy="false"
                theme="light"
                borderRadius="8px"
                ref="codeEditor"
                @change="updateJsonData"
              />
            </div>
          </template>
        </Card>
      </div>
    </div>
  </template>
</template>

<style scoped>

</style>
